import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './components/Home'
import Mudanza from './components/Forms/Mudanza'
import Fletes from './components/Forms/Fletes'
import Contacto from './components/Site/Contacto'
import Preguntas from './components/Site/Preguntas'
import Nosotros from './components/Site/Nosotros'
import NotFound from './components/Site/404'
import Solicitud from './components/Site/Solicitud'
import Solicitud_Flete from './components/Site/Solicitud_Flete'
import Clientes from './components/Site/Clientes'
import Terminos from './components/Site/Terminos'
import Register from './components/Site/Register'
import PortalCliente from './components/Users/PortalCliente'
import Respuesta_Convenio from './components/Site/Respuesta_Convenio'
import Respuesta_Transportista from './components/Site/Respuesta_Transportista'
import seguimiento from './components/Site/seguimiento'
import Santiago from './components/Site/Services/Places/Santiago'
import LasCondes from './components/Site/Services/Places/LasCondes'
import Express from './components/Forms/Express'
import Blog from './components/Forms/Blog'
import LandingPageE from './components/Site/LandingPageE'
import LandingPageM from './components/Site/LandingPageM'
import Demo from './components/Demo/Demo'


/* import { component } from 'vue/types/umd' */

//import NotFound from './components/pages/404.vue'

Vue.use(VueRouter)

const Router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/portalCliente",
			name: "portalCliente",
			component: PortalCliente
		},
		{
			path: "/cotizador-mudanza/:token?",
			name: "mudanza",
			component: Mudanza
		},
		{
			path: "/cotizador-fletes",
			name: "fletes",
			component: Fletes
		},
		{
			path: "/places/santiago",
			name: "MudanzaSantiago",
			component: Santiago
		},
		{
			path: "/places/lasCondes",
			name: "MudanzaLasCondes",
			component: LasCondes
		},
		{
			path: "/register",
			name: "register",
			component: Register
		},
		{
			path: "/solicitud/:id/:token?",
			name: "solicitud",
			component: Solicitud
		},
		{
			path: "/solicitud_flete/:id/:token?",
			name: "solicitud",
			component: Solicitud_Flete
		},
		{
			path: "/contacto/:token?",
			name: "contacto",
			component: Contacto
		},
		{
			path: "/preguntas",
			name: "preguntas",
			component: Preguntas
		},
		{
			path: "/nosotros",
			name: "nosotros",
			component: Nosotros
		},
		{
			path: "/clientes",
			name: "clientes",
			component: Clientes
		},
		{
			path: "/terminos",
			name: "terminos",
			component: Terminos
		},
		{
			path: "/respuesta_convenio",
			name: "Respuesta Convenio",
			component: Respuesta_Convenio
		},
		{
			path: "/respuesta_transportista",
			name: "Respuesta Transportista",
			component: Respuesta_Transportista
		},
		{
			path: "/seguimiento",
			name: "seguimiento",
			component: seguimiento
		},
		{
			path: "/Express",
			name: "Express",
			component: Express
		},
		{
			path: "/Blog",
			name: "Blog",
			component: Blog
		},
		{
			path: "/LandingPageFletes",
			name: "LandingPageE",
			component: LandingPageE
		},
		{
			path: "/LandingPageMudanzas",
			name: "LandingPageM",
			component: LandingPageM
		},
		{
			path: "/Demo",
			name: "Demo",
			component: Demo
		},
		{
			path: "/MudanzaDemo",
			component: () => import('@/components/Demo/Forms/Mudanza'),
			name: "MudanzaDemo"
		},
		{ path: '*', component: NotFound }
	]
})

export default Router